module.exports = __webpack_public_path__ + "static/depoimento17-1ee53f084816e55d5ec1cfcc0aa70383.png";